import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MeusContatosCreatePageRoutingModule } from './meus-contatos-create-routing.module';

import { MeusContatosCreatePage } from './meus-contatos-create.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MeusContatosCreatePageRoutingModule
  ],
  declarations: [MeusContatosCreatePage]
})
export class MeusContatosCreatePageModule {}
